import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { wait } from "../utility/wait";

interface ChatSatisfactionQuestionProps {
  satisfactionValue: number | null;
  setSatisfactionValue: React.Dispatch<React.SetStateAction<number | null>>;
  isAutoPageTurn?: boolean;
  questionnairePage: number;
  switchTab: (next: number) => void;
}

export const ChatSatisfactionQuestion: React.FC<
  ChatSatisfactionQuestionProps
> = ({
  satisfactionValue,
  setSatisfactionValue,
  isAutoPageTurn,
  questionnairePage,
  switchTab,
}) => {
  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setSatisfactionValue(Number((event.target as HTMLInputElement).value));
    if (isAutoPageTurn) {
      await wait(100);
      switchTab(questionnairePage + 1);
    }
  };

  return (
    <>
      <Box sx={{ padding: "1rem" }}>
        <Typography variant="caption">
          先ほどのチャットで、話したかった内容を話すことが出来たと感じましたか？
          もっとも当てはまるものを選んでください。
        </Typography>
      </Box>
      <Box sx={{ padding: "1rem" }}>
        <FormControl>
          <RadioGroup onChange={handleChange} value={satisfactionValue}>
            <FormControlLabel
              value={7}
              control={<Radio />}
              label="7：十分に話しきることが出来た"
            />
            <FormControlLabel value={6} control={<Radio />} label="6" />
            <FormControlLabel value={5} control={<Radio />} label="5" />
            <FormControlLabel value={4} control={<Radio />} label="4" />
            <FormControlLabel value={3} control={<Radio />} label="3" />
            <FormControlLabel value={2} control={<Radio />} label="2" />
            <FormControlLabel
              value={1}
              control={<Radio />}
              label="1：話したかったことがまったく話せなかった"
            />
          </RadioGroup>
        </FormControl>
      </Box>
    </>
  );
};
